export interface PostalCodeItem {
    Status: string;
    [key: string]: any;
}

export interface PostalCodeOutput {
    output_port: PostalCodeItem[];
    [key: string]: any;
}

export const ZipCodeErrorMessage = {
    NOT_FOUND: 'Zip Code not found.',
    UNDEFINED_API: 'API or postal code param is not defined.',
    UNPROCESSABLE_ENTITY: 'Postal code param does not match the API URL.',
};

export const ZipCodeDefaults = {
    PLACEHOLDER: 'Zip Code',
    LENGTH: 5,
    OUTPUT_KEY: 'output_port',
};
